import { getStoredState, KEY_PREFIX, REHYDRATE } from 'redux-persist';

import { reportThrottled } from '#shared';

import { uiSessionPersistConfig } from './persistConfig';

import type { UnknownAction } from '@reduxjs/toolkit';

const STORAGE_KEY = `${KEY_PREFIX}${uiSessionPersistConfig.key}`;
const REPORT_THROTTLE_MS = 60_000;

export const listenForUiSessionWrites = (
  dispatch: (action: UnknownAction) => unknown,
): (() => void) => {
  const onStorage = (event: StorageEvent) => {
    if (event.key !== STORAGE_KEY || event.newValue === null) {
      return;
    }
    void getStoredState(uiSessionPersistConfig).then(
      payload => {
        if (payload) {
          dispatch({
            type: REHYDRATE,
            key: uiSessionPersistConfig.key,
            payload,
          });
        }
      },
      (error: unknown) => {
        reportThrottled(
          'ui-session:cross-tab-rehydrate',
          'uiSession write from another tab could not be read',
          {
            throttleMs: REPORT_THROTTLE_MS,
            level: 'warning',
            extra: {
              errorName: error instanceof Error ? error.name : typeof error,
            },
          },
        );
      },
    );
  };

  // redux-persist writes the slice whole and rehydrates only at load, so without
  // this a stale tab's next write reverts this one. Falsified by a redux-persist
  // that merges per field.
  window.addEventListener('storage', onStorage);
  return () => window.removeEventListener('storage', onStorage);
};
